/* eslint-disable @typescript-eslint/no-unused-vars */
import { memo } from 'react'
import { useIntl } from 'react-intl'
import type { CellValue, IdType } from 'react-table'
import type { State } from '@racepointenergy/swc/scs/features/host-states'

import { messages } from './messages'
import theme from 'theme_'
import { Body12, BodyPrimary } from 'components/Typography/Labels'
import {
  MobileTableBlock,
  MobileTableBlockCell,
  MobileTableBlockRow,
} from 'components/Table/MobileBlock/styles'
import { CellColumn, CellRow, StyledToggle } from './styles'
import { dealerConfigurePowerCyclePdu } from './pdu'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import { makePublicUrl } from 'app/utils/publicUrl'

const powerCycleIcon = makePublicUrl('images/powerIcons/power-cycle.svg')

interface PowerCycleBlockProps {
  values: Record<IdType<State>, CellValue>
  original: Record<IdType<State>, CellValue>
}

const outlet = (outlet: number) => {
  if (outlet === 5) {
    return '5, 6'
  } else if (outlet === 6) {
    return '7, 8'
  }

  return outlet
}

export const PowerCycleBlock = ({ values, original }: PowerCycleBlockProps) => {
  const { formatMessage } = useIntl()
  const [updateDealerConfigurePowerCyclePdu, { status: processStatus }] =
    dealerConfigurePowerCyclePdu.useMutation()

  const handleClick = () => {
    updateDealerConfigurePowerCyclePdu({
      id: original.homeId,
      loadName: original.circuitName,
      toggle: true,
    })
  }

  const onChange = () => {
    updateDealerConfigurePowerCyclePdu({
      id: original.homeId,
      loadName: original.circuitName,
      value: values.State === 1 ? 0 : 1,
      toggle: false,
    })
  }

  return (
    <MobileTableBlock>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <CellColumn>
            <BodyPrimary bold color={theme.colors.otterWarmBlack}>
              {values.Device}
            </BodyPrimary>

            <CellRow>
              <Body12 color={theme.colors.darkeyGrey}>
                {formatMessage(messages.headerOutlet)}
              </Body12>
              <BodyPrimary color={theme.colors.otterWarmBlack}>
                {outlet(values.Outlet)}
              </BodyPrimary>
            </CellRow>
          </CellColumn>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <CellRow>
            <StyledToggle
              icons={false}
              disabled={processStatus === 'pending'}
              checked={values.State === 1}
              onChange={(e: any) =>
                original.setConfirmModal({
                  homeId: original.homeId,
                  cycle: false,
                  onConfirm: onChange,
                })
              }
            />
            <CommonLinkButton
              onClick={() =>
                original.setConfirmModal({
                  homeId: original.homeId,
                  cycle: true,
                  onConfirm: handleClick,
                })
              }
              disabled={processStatus === 'pending'}
            >
              <img src={powerCycleIcon} alt="Power cycle" />
            </CommonLinkButton>
          </CellRow>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
    </MobileTableBlock>
  )
}

export default memo(PowerCycleBlock)
